import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from '../../../../axiosConfig';
import LatestDevelopments from './LatestDevelopments';
import styles from '../../MicroProbe/MicroProbe.module.css';
import IdeasMaker from '../../IdeasMaker';
import TopicGather from '../../TopicGather';
import LongTermOutlook from './LongTermOutlook';
import PerformanceOverview from './PerformanceOverview';
import CentralBankHighlight from './CentralBankHighlight';
import EconomyHighlight from './EconomyHighlight';
import StockHighlight from './StockHighlight';
import ChatNumbersLongTermOutlook from './ChatNumbersLongTermOutlook';
import VideoInsight from '../../MicroProbe/Companies/VideoInsightForDashboard';
import EconomicDataUS from './EconomicDataUS';
import ChatNumbersUS from './ChatNumbersUS';
import ChatNumbersShortTermEconomics from './ChatNumbersShortTermEconomics';
import ChatNumbersShortTermEconomicsUS from './ChatNumbersShortTermEconomicsUS';
import DocumentUploads from '../../MicroProbe/Companies/MicroProbeDocuments';
//import ChatNumbersNearTermForecast from './ChatNumbersNearTermForecast';
//import ShortTermEconomics from './ShortTermEconomics';
//import NearTermForecast from './NearTermForecast';


const Countries = () => {
  const { economyName } = useParams();
  const [inputData, setInputData] = useState(null);
  const [expandedSections, setExpandedSections] = useState(new Set()); // Track multiple expanded sections
  
  useEffect(() => {
    const fetchInputData = async () => {
      try {
        const response = await axios.get(`/api/country/name/${economyName}`);
        setInputData(response.data);

      } catch (error) {
        console.error('Error fetching currency data:', error);
      }
    };
  
    fetchInputData();
  }, [economyName]);

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(sectionId)) {
        newSet.delete(sectionId);
      } else {
        newSet.add(sectionId);
      }
      return newSet;
    });
  };

return (
  <div className={styles.container}>
    <h1 className={styles.title}>{economyName}</h1>

    {inputData && (
      <>  
        {/* Latest Developments Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('overview')}
          >
            <h2>Latest Developments</h2>
            <span className={`${styles.arrow} ${expandedSections.has('overview') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('overview') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg1}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <LatestDevelopments  inputData={inputData} />
              </div>
            </div>
          </div>
        </div>

        {/* Economic Context Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('economic')}
          >
            <h2>Macro Context</h2>
            <span className={`${styles.arrow} ${expandedSections.has('economic') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('economic') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg2}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <EconomyHighlight inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg2}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <CentralBankHighlight inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg2}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <StockHighlight inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg2}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <PerformanceOverview  inputData={inputData} />
              </div>
            </div>
          </div>
        </div>

        {/* Performance Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('performance')}
          >
            <h2>Performance</h2>
            <span className={`${styles.arrow} ${expandedSections.has('performance') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('performance') ? 'block' : 'none' }}>
            {inputData?.name === 'United States' && (
              <>
                <div className={`${styles.section} ${styles.sectionBg3}`}>
                  <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                    <EconomicDataUS inputData={inputData} />
                  </div>
                </div>

                <div className={`${styles.section} ${styles.sectionBg3}`}>
                  <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                    <ChatNumbersUS inputData={inputData} />
                  </div>
                </div>
              </>
            )}

            <div className={`${styles.section} ${styles.sectionBg3}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                {inputData?.name === 'United States' ? (
                  <ChatNumbersShortTermEconomicsUS inputData={inputData} />
                ) : (
                  <ChatNumbersShortTermEconomics inputData={inputData} />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Risk and Signals Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('signals')}
          >
            <h2>Risks & Signals</h2>
            <span className={`${styles.arrow} ${expandedSections.has('signals') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('signals') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg1}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <LongTermOutlook inputData={inputData} />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg1}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
                <ChatNumbersLongTermOutlook inputData={inputData} />
              </div>
            </div>
          </div>
        </div>


        {/* Documents and Media Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('documents')}
          >
            <h2>Documents & Media</h2>
            <span className={`${styles.arrow} ${expandedSections.has('documents') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('documents') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionBg4}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto'}}> 
                <TopicGather />
              </div>
            </div>

            <div className={`${styles.section} ${styles.sectionBg4}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto'}}> 
                <DocumentUploads />
              </div>
            </div>
            
            <div className={`${styles.section} ${styles.sectionBg4}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto'}}>
                <VideoInsight />
              </div>
            </div>
          </div>
        </div>

        {/* Report Section */}
        <div className={styles.collapsibleSection}>
          <button 
            className={styles.sectionHeader}
            onClick={() => toggleSection('report')}
          >
            <h2>Reports</h2>
            <span className={`${styles.arrow} ${expandedSections.has('report') ? styles.open : ''}`}>›</span>
          </button>
          <div style={{ display: expandedSections.has('report') ? 'block' : 'none' }}>
            <div className={`${styles.section} ${styles.sectionQuarter} ${styles.sectionBg6}`}>
              <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>   
                <IdeasMaker />
              </div>
            </div>
          </div>
        </div>

      </>
    )}

    <Link to="/entity-intelligence" style={{ marginTop: '40px', marginLeft: '10px', display: 'inline-block' }}>Back</Link>
  </div>
);
};

export default Countries;